import { Link } from "react-router-dom"

function TileFlip({naslov, ikonica, boja, poruka, link, width = '100%', height = '100%'}){
    return  <div className="flipbox" style={{width: width, height: height}}>
        <Link to={link} className="tile-flip">
            <div className="back" style={{background: boja}}>
                <div className="tile-flip-poruka" dangerouslySetInnerHTML={{__html: poruka}}></div>
            </div>
            <div className="front">
                <p style={{color: boja}} className="tile-flip-naslov">{naslov}</p>
                <img src={ikonica}></img>
            </div>
            
        </Link>
    </div>
}

export default TileFlip